// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__yj3dH","left":"toggle_left__oYT64","right":"toggle_right__AKlJY","active":"toggle_active__nsH4O"};